
import { ExcelMapperSettings } from "@/models/excel-mapper-settings";
import { ExcelMapperService } from "@/utils/services/excel-mapper-service";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			settings: [] as ExcelMapperSettings[]
		};
	},
	props: {
		service: {
			type: Object as ()=>ExcelMapperService,
			required: true
		}
	},
	methods: {
		async fetch(){
			this.settings = await this.service.getSettings();
		},
		editSettings(settings:ExcelMapperSettings){
			this.$emit("edit-settings", settings);
		},
		createNewSettings(){
			this.$emit("edit-settings", new ExcelMapperSettings());
		},
		useSettings(settings:ExcelMapperSettings){
			this.$emit("settings", settings);
		},
		async deleteSettings(settings:ExcelMapperSettings){
			let text = this.$ct("are-you-sure-you-want-to-delete-settings", {name: settings.Name});
			let result = await this.$wf.confirm(text, this.$ct("common.yes"), this.$ct("common.no"), this.$ct("common.warning"), "warning");
			if (!result) return;
			await this.service.deleteSetting(settings);
			await this.fetch();
		},
		close(){
			this.$emit("close");
		}
	},
	async mounted(){
		await this.fetch();
	},
	i18nEx: {
		componentPrefix: "components.excel-mapper"
	}
});
